import React from "react";
import Header from "../components/Header";
import { useSystemTheme } from "../utils/useSystemTheme";

const FAQUI = () => {
    const theme = useSystemTheme();

    const gradientClass =
        theme === "dark"
            ? "bg-gradient-to-tr from-[#1f2937] via-[#111827] to-[#0f172a]"
            : "bg-gradient-to-tr from-[#f0f4ff] via-[#e2f0ff] to-[#d0f0e8]";

    const textClass = theme === "dark" ? "text-white" : "text-gray-900";

    const faqs = [
        {
            question: "Қосымшаны қалай қолданамын?",
            answer: "Басты бетте тіркеліп, қалаған бөлімге кіріңіз.",
        },
        {
            question: "Жүйе интернетсіз жұмыс істей ме?",
            answer: "Қазіргі таңда тек интернетпен ғана жұмыс істейді.",
        },
        {
            question: "Қолдау көрсетуге қалай хабарласамын?",
            answer: (
                <>
                    Сіз бізге электрондық пошта арқылы{" "}
                    <a href="mailto:musaaldanazarov@gmail.com" className="underline text-blue-500">
                        musaaldanazarov@gmail.com
                    </a>{" "}
                    немесе{" "}
                    <a href="https://wa.me/77081056354" target="_blank" rel="noopener noreferrer" className="underline text-green-500">
                        WhatsApp
                    </a>{" "}
                    арқылы хабарласа аласыз.
                </>
            ),
        },
        {
            question: "Бұл қандай қосымша?",
            answer: "Бұл — қазақ тіліндегі аудиокітаптарды тыңдауға арналған веб-сайт. Сіз оны мобильді құрылғыңызға PWA ретінде орнатып, қолдана аласыз.",
        },
        {
            question: "Барлық кітаптар тегін бе?",
            answer: "Көптеген кітаптар тегін, бірақ кейбір арнайы кітаптарды сатып алуға болады.",
        },
        {
            question: "Қосымшаны қалай орнатамын?",
            answer: "Сайтты ашқанда шолу құрылғысы 'қосымшаны орнату' батырмасын ұсынады. Сол арқылы орната аласыз.",
        },
    ];

    return (
        <div className={`min-h-screen flex flex-col ${gradientClass} backdrop-blur-xl`}>
            <Header />
            <div className="flex-grow px-4 py-6 space-y-6">
                <h1 className={`text-3xl font-bold ${textClass}`}>Жиі қойылатын сұрақтар</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className={`p-4 rounded-xl shadow ${theme === "dark" ? "bg-gray-800" : "bg-white"}`}>
                            <h2 className={`font-semibold text-lg mb-2 ${textClass}`}>{faq.question}</h2>
                            <p className={`${textClass} text-sm`}>{faq.answer}</p>
                        </div>
                    ))}
                </div>

                <div className={`mt-8 border-t pt-4 ${theme === "dark" ? "border-gray-700" : "border-gray-300"}`}>
                    <h2 className={`text-xl font-semibold mb-2 ${textClass}`}>Байланыс:</h2>
                    <p className={`${textClass}`}>
                        ✉️ Электрондық пошта: <a href="mailto:musaaldanazarov@gmail.com" className="underline">musaaldanazarov@gmail.com</a><br />
                        📱 WhatsApp: <a href="https://wa.me/77081056354" className="underline">+77081056354</a>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default FAQUI;